import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Box } from '@mui/material';
import ApiService from '../../Api/ApiController';
import Swal from 'sweetalert2';

export default function BankSection() {
  const [formData, setFormData] = useState({
    bank_account: '',
    ifsc_code: '',
    upi_id: '',
    qr_image: null,
    qr_image_url: '', // Store existing QR image URL
    account_holder_name:'',
    bank_name:'',
  });

  useEffect(() => {
    getBankDetails();
  }, []);

  const getBankDetails = () => {
    ApiService.getBankDetails()
      .then((response) => {
        if (response.data.status === true && response.data.data) {
          const { bank_account, ifsc_code, upi_id, qr_image ,account_holder_name ,bank_name} = response.data.data;
          setFormData({
            bank_account: bank_account || '',
            ifsc_code: ifsc_code || '',
            upi_id: upi_id || '',
            qr_image: null,
            qr_image_url: qr_image || '',
            account_holder_name: account_holder_name || '',
            bank_name: bank_name || '',
          });
        }
      })
      .catch((error) => console.error("Error fetching bank details:", error));
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, qr_image: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('bank_account', formData.bank_account);
    data.append('ifsc_code', formData.ifsc_code);
    data.append('upi_id', formData.upi_id);
    data.append('bank_name', formData.bank_name);
    data.append('account_holder_name', formData.account_holder_name);
    if (formData.qr_image) {
      data.append('qr_image', formData.qr_image);
    }

    ApiService.addbankdetails(data)
      .then((response) => {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: response.data.status === true ? 'success' : 'error',
          title: response.data.message,
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });

        if (response.data.status === true) {
          getBankDetails(); // Refresh the details after submission
        }
      })
      .catch((error) => console.error("Error submitting bank details:", error));
  };

  return (
    <Box sx={{ maxWidth: 500, mx: 'auto', p: 3, boxShadow: 3, borderRadius: 2 }}>
      <Typography variant="h5" gutterBottom>
        Add Bank Details
      </Typography>
      
      <form onSubmit={handleSubmit}>
        <TextField
          label="Bank Account Number"
          name="bank_account"
          value={formData.bank_account}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Account Holder Name"
          name="account_holder_name"
          value={formData.account_holder_name}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Bank Name"
          name="bank_name"
          value={formData.bank_name}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />

        <TextField
          label="IFSC Code"
          name="ifsc_code"
          value={formData.ifsc_code}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />

        <TextField
          label="UPI ID"
          name="upi_id"
          value={formData.upi_id}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <Button variant="contained" component="label" fullWidth sx={{ mt: 2 }}>
          Upload QR Image
          <input type="file" name="qr_image" accept="image/*" hidden onChange={handleFileChange} />
        </Button>

        {formData.qr_image && (
          <Typography sx={{ mt: 1, fontSize: 14, color: 'gray' }}>
            {formData.qr_image.name}
          </Typography>
        )}

        {formData.qr_image_url && !formData.qr_image && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2">Existing QR Image:</Typography>
            <img src={formData.qr_image_url} alt="QR Code" width={100} height={100} style={{ borderRadius: 5, border: "1px solid #ccc" }} />
          </Box>
        )}

        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 3 }}>
          Submit
        </Button>
      </form>
    </Box>
  );
}
